import { render, staticRenderFns } from "./ServiceFormCourierDeliveryFields.vue?vue&type=template&id=510fb766"
import script from "./ServiceFormCourierDeliveryFields.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceFormCourierDeliveryFields.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInput: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/components/ui/UiInput.vue').default})
